import React from 'react';

import { Button } from 'scouting-ui/lib';
import { useSlate } from 'slate-react';

import type { CustomEditor } from './EditorTextArea.types';
import { onPointerDown } from './EditorTextArea.utils';
import { getIcon } from './Icon';

const RedoButton = () => {
  const editor = useSlate();

  const onClick = () => {
    try {
      (editor as CustomEditor).redo?.();
    } catch {
      // ignore
    }
  };

  return (
    <Button
      data-test-id="block-button-redo"
      ghost
      icon={getIcon('redo')}
      onClick={onClick}
      onPointerDown={onPointerDown}
      size="small"
    />
  );
};

export default RedoButton;
